var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTestTube = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "m14 4.67-9.453 9.453a1.886 1.886 0 0 1-2.66-2.674l9.447-9.446m-.667-.667 4 4M8 10.669H2.667"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTestTube);
export default ForwardRef;